import { UserStatus } from '../../../../types/UserStatus';
import { Tag, TagProps } from '../../../cdl/Tag/Tag';
import { useEnums } from '../../../common/hooks/useEnums';

interface UserStatusTagProps {
    status: UserStatus;
}

const getStatusTagVariant = (status: UserStatus): TagProps['variant'] => {
    switch (status) {
        case UserStatus.ACTIVE:
            return 'positive';
        case UserStatus.INACTIVE:
            return 'default';
        case UserStatus.INVITED:
            return 'accent';
        default:
            return 'default';
    }
};

export const UserStatusTag = ({ status }: UserStatusTagProps) => {
    const { getHumanReadableValue } = useEnums();

    return <Tag variant={getStatusTagVariant(status)}>{getHumanReadableValue('status', status)}</Tag>;
};
